export const MUSICFORGE_HF_BUCKET = "copperscout1/MusicForge-User";
export const MUSICFORGE_HF_BUCKET_URI = `hf://buckets/${MUSICFORGE_HF_BUCKET}`;

/** One shared bucket; each suite email owns `user/{key}/`. */
export function userShelfKey(email: string): string {
  const e = email.trim().toLowerCase();
  const at = e.indexOf("@");
  const local = (at >= 0 ? e.slice(0, at) : e).replace(/[^a-z0-9._-]+/g, "-") || "user";
  const domain = (at >= 0 ? e.slice(at + 1) : "local").replace(/[^a-z0-9.-]+/g, "-") || "local";
  return `${local}__${domain}`.slice(0, 96);
}

export function mimicFileId(id: string): string {
  return id.replace(/[^a-zA-Z0-9._-]+/g, "-").slice(0, 80) || "mimic";
}

export function mimicBucketPrefix(email: string): string {
  return `user/${userShelfKey(email)}/mimics`;
}

export function mimicBucketPath(email: string, id: string): string {
  return `${mimicBucketPrefix(email)}/${mimicFileId(id)}.music-mimic`;
}
